import get from 'lodash/get'
import getCentreStore from './get-centre-stores'

export const getStoreTitle = (centre, entry) => {
  const store = getCentreStore(centre, entry)
  if (store && store.length > 0) {
    return store.length > 1 ? 'Multiple stores' : get(store, ['0', 'title'])
  }
  return null
}
